import clienteAxios from "../config/axios";

export async function getClientProrationByTDoc(tDocID) {
    return clienteAxios.get(`/clientProrationByTDoc/${tDocID}`);
}

export async function updateListClientProrationByTDoc(tDoc, prorrateoList) {
    return clienteAxios.put('/clientProration/updateListByTDoc', { tDoc, prorrateoList });
}
